import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './Clock.css';
import dayjs from 'dayjs';
const Clock = () => {
    const [current, setCurrent] = useState(dayjs());
    useEffect(() => {
        const id = setInterval(() => {
            setCurrent(dayjs());
        }, 1000);
        return () => clearInterval(id);
    }, []);
    return (_jsx("span", { className: "clock", children: current.format('ddd DD.MM HH:mm:ss') }));
};
export default Clock;
